export class Ramo {
    id: number;
    descripcion:string;
  }